import Vue from "vue";
import Vuex from "vuex";
import axiosInstance from "@/plugins/axios";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    snackbar: {
      show: false,
      timeout: -1,
      color: "success",
      message: null,
      onStateChange: false,
    },
    breadcrumbs: [],
    currentUser: null,
    pageFilters: null,
  },
  getters: {},
  mutations: {
    showSnackbar(state, settings) {
      state.snackbar = {
        show: true,
        timeout: 3000, //settings.timeout || 0,
        color: settings.color || "success",
        message: settings.message || "",
        onStateChange: settings.onStateChange || false,
      };
      setTimeout(() => (state.snackbar.show = false), 3000);
    },
    hideSnackbar(state) {
      state.snackbar = {
        show: false,
      };
    },
    setBreadcrumbs(state, breadcrumbs) {
      const oldTitle = state.breadcrumbs[0]?.text ?? null;
      const newTitle = breadcrumbs[0]?.text ?? null;
      state.breadcrumbs = breadcrumbs;
      if (oldTitle && oldTitle !== newTitle) {
        state.pageFilters = null;
      }
    },
    setUser(state, currentUser) {
      state.currentUser = currentUser;
    },
    setPageFilters(state, payload) {
      state.pageFilters = payload;
    },
    resetPageFilters(state) {
      state.pageFilters = null;
    },
  },
  actions: {
    handleFileUpload({ dispatch }, event) {
      return new Promise((resolve, reject) => {
        const file = event.target.files[0];
        if (!file) {
          return resolve({
            csvData: { data: [], headers: [] },
            errorMessage: "No file selected.",
          });
        }

        const reader = new FileReader();
        reader.onload = async (e) => {
          const csv = e.target.result;
          try {
            const csvData = await dispatch("parseCSV", csv); // ✅ Use context.dispatch
            resolve({ csvData, errorMessage: "" });
          } catch (error) {
            reject({
              csvData: { data: [], headers: [] },
              errorMessage: "CSV parsing failed.",
            });
          }
        };
        reader.onerror = () => {
          reject({
            csvData: { data: [], headers: [] },
            errorMessage: "Failed to read file.",
          });
        };

        reader.readAsText(file);
      });
    },
    parseCSV(_, csv) {
      const lines = csv
        .trim()
        .split("\n")
        .filter((line) => line.trim());
      const headers = lines[0].split(",").map((header) => header.trim());

      const data = lines
        .slice(1)
        .map((line) => {
          const values = line.match(/(".*?"|[^",]+)(?=\s*,|\s*$)/g) || []; // Handles quoted values

          if (values.length !== headers.length) return null; // Ignore malformed rows

          return headers.reduce((object, header, index) => {
            let value = values[index].trim();
            object[header] =
              value === "NULL" ? null : value.replace(/^"|"$/g, ""); // Remove quotes
            return object;
          }, {});
        })
        .filter((row) => row); // Remove null values from invalid rows
      return { data, headers };
    },
    throwError(_, response) {
      let errors = response.data.errors;
      console.log(errors);
      if (!errors) {
        return response.statusText;
      }
      if (typeof errors == "string") return errors;
      if (Array.isArray(errors)) errors = errors[0];
      const [[key, [value]]] = Object.entries(errors);
      let splitArray = key.split("_");
      let joinedKeyString = splitArray
        .filter((item) => item !== "id")
        .join(" ");
      let keyString =
        joinedKeyString[0].toLocaleUpperCase() + joinedKeyString.slice(1);
      return `${keyString} ${value}`;
    },
    async initializeUser({ commit }) {
      const token = localStorage.getItem("token");
      if (!token) return;

      try {
        const res = await axiosInstance.get("/find_me", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        commit("setUser", res.data.data);
      } catch (err) {
        // token is invalid or expired
        localStorage.removeItem("token");
        commit("setUser", null);
      }
    },
    downloadErrorCsv(_, { errorCsvBlob, csvTitle }) {
      const url = window.URL.createObjectURL(errorCsvBlob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", `${csvTitle} Errors.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      return;
    },
  },

  modules: {},
});
